import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import TableView from "../Common/TableView";
import { ObrasTableConfigs } from "./Obras.config";
import { generalObjectBuilder, genericDelete, genericGetWithProcessor, genericPost, genericUpdate, OBRAS_EXTENSION, paginatedGetWithProcessor } from "../../services/api.service";
import {  userIsAdmin } from "../../utils/UserInfoHandler"
import FactoryFloorView from "../FactoryFloor";
import useMemoryState from "../../hooks/memoryStateHook";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ViewHeader } from "../Common/ViewHeader";


export default function Obras() {


    const [tab, setTab] = useMemoryState('obras-tab', 0)

    const cachedObra = localStorage.getItem('obraForm') ? JSON.parse(localStorage.getItem('obraForm') as string) : null;


    return (<>
        {/* <ViewHeader pageTitle="Obras"/> */}
    {userIsAdmin() ? <div style={{margin: 20}}>

        {/* TODO add this back to Tabs */}
        <Tabs  selectedIndex={tab} onSelect={(index) => setTab(index)}>
            <TabList>
                <Tab>Gestão de Obras Adjudicadas</Tab>
                <Tab>Processar operação para entrega</Tab>

            </TabList>
            <TabPanel>
                <TableView
                    title={"Obras"}
                    postEntity={genericPost(OBRAS_EXTENSION)}
                    editEntity={genericUpdate(OBRAS_EXTENSION)}
                    deleteEntity={genericDelete(OBRAS_EXTENSION)}
                    addButtonText={ cachedObra ? `Terminar obra ${cachedObra.number}` :"Nova Obra"}
                    tableConfigs={ObrasTableConfigs}
                    entityName={"Obra"}
                    dataBuildFunction={generalObjectBuilder(ObrasTableConfigs)}
                    idProp={"number"}
                    allowCopy={true}
                    reroute={true}
                    customForm
                />
            </TabPanel>
            <TabPanel>
                <FactoryFloorView />
            </TabPanel>

        </Tabs>

    </div> : <FactoryFloorView />}</>)

}

